import classNames from 'classnames';
import { systemApi } from '../../APIs/systemApi';
import { APIError, useGet } from '../../hooks/useApi';
import { Icon, Icons, SpinnerIcon } from '../atomic/icons';

export function SystemBanner() {
    const {
        data: systemInfo,
        error: systemError,
        isLoading,
    } = useGet(systemApi.get.info);
    if (!systemInfo && !systemError && isLoading) {
        return <SpinnerIcon />;
    }
    let message: { type: 'warning' | 'fatal'; message: string } | null = null;
    if (systemError instanceof APIError) {
        if (systemError.status === 404) {
            message = {
                type: 'fatal',
                message: 'サーバーと接続できません',
            };
        } else {
            message = {
                type: 'fatal',
                message: `サーバで問題が発生しました (${systemError.status})`,
            };
        }
    }
    if (systemInfo?.maintenance) {
        message = {
            type: 'warning',
            message: `メンテナンス中です`,
        };
    }
    if (message) {
        return (
            <div
                className={classNames(
                    'system-banner',
                    `system-banner--${message.type}`
                )}
            >
                <Icon
                    icon={
                        message.type == 'fatal'
                            ? Icons.FatalError
                            : Icons.Warning
                    }
                />
                <span>{message.message}</span>
            </div>
        );
    }
    return <></>;
}
